//modal
const modalDotLeft = require("./modal/modalDotLeft.png")
const modalDotRight = require("./modal/modalDotRight.png")

//promotion
const homeBgPng = require("./promotion/homeBg.png")
const homeBgWebp = require("./promotion/homeBg.webp")
const roundsBarPng = require("./promotion/roundsBar.png")
const roundsBarWebp = require("./promotion/roundsBar.webp")
const aboutActivity = require("./promotion/aboutActivity.png")
const promotionBar = require("./promotion/promotionBar.png")
const prizesPng = require("./promotion/prizes.png")
const prizesWebp = require("./promotion/prizes.webp")
const rulesOnePng = require("./promotion/rulesOne.png")
const rulesOneWebp = require("./promotion/rulesOne.webp")
const rulesTwoPng = require("./promotion/rulesTwo.png")
const rulesTwoWebp = require("./promotion/rulesTwo.webp")

//mystatus
const progressWrap = require("./mystatus/progressWrap.png")
const assistProcess = require("./mystatus/assistProcess.png")
const pace = require("./mystatus/pace.gif")
const walk = require("./mystatus/walk.gif")
const success = require("./mystatus/success.gif")
const avatar = require("./mystatus/avatar.png")
const glow = require("./mystatus/glow.png")
const treasure = require("./mystatus/treasure.png")

//claims
const claimBgPng = require("./claims/claimBg.png")
const claimBgWebp = require("./claims/claimBg.webp")
const aqy = require("./claims/aqy.png")
const jd50 = require("./claims/jd50.png")
const jd100 = require("./claims/jd100.png")
const walmart = require("./claims/walmart.png")
const tx = require("./claims/tx.png")
const grab = require("./claims/grab.png")
const claimFail = require("./claims/claimFail.png")

//my prize
const jd100Origin = require("./myprize/jd100Origin.png")
const jd50Origin = require("./myprize/jd50Origin.png")
const txOrigin = require("./myprize/txOrigin.png")
const walmartOrigin = require("./myprize/walmartOrigin.png")
const aqyOrigin = require("./myprize/aqyOrigin.png")
const emptyBg = require("./myprize/emptyBg.png")

export {
  modalDotRight,
  modalDotLeft,
  homeBgPng,
  homeBgWebp,
  roundsBarPng,
  roundsBarWebp,
  aboutActivity,
  promotionBar,
  prizesPng,
  prizesWebp,
  rulesOnePng,
  rulesOneWebp,
  rulesTwoPng,
  rulesTwoWebp,
  progressWrap,
  assistProcess,
  pace,
  walk,
  success,
  avatar,
  glow,
  treasure,
  claimBgPng,
  claimBgWebp,
  aqy,
  jd50,
  jd100,
  walmart,
  tx,
  grab,
  jd100Origin,
  jd50Origin,
  txOrigin,
  walmartOrigin,
  aqyOrigin,
  emptyBg,
  claimFail,
}
